import { cloneDeep } from 'lodash'

import { toArray, getInt, getText, getScore, isDuplicate } from './common'

import {
  CheckListDetail,
  JobType,
  SubJobType,
} from 'features/checklist/constructPlan/types'

import { original } from 'features/checklist/constructPlan/reducer'

export const toCheckList = (data: string): any => {
  let checklist: CheckListDetail = cloneDeep(original)

  let mode = ''
  const rows = toArray(data)
  rows.forEach((row: any, index: number) => {
    const cmd = getText(row, 0).toLowerCase()
    switch (cmd) {
      case 'checklist name':
        mode = ''
        checklist.CheckListName = getText(row, 1)
        break

      case 'checklist type':
        mode = ''
        checklist.ProjectTypeID = getInt(row, 1)
        break

      case 'score':
        mode = ''
        checklist.ScoreRange = getScore(row)
        break

      case 'return date':
        mode = ''
        checklist.NumOfReturnDate = getInt(row, 1)
        break

      case 'ncr':
        mode = 'ncr'
        addNcr(checklist, row, index)

        break
      case 'work type':
        mode = 'work type'
        addWorkType(checklist, row, index)

        break
      case 'description':
        mode = 'description'
        addDefectDetail(checklist, row, index)

        break

      case 'score range':
      case 'note':
        mode = ''
        break

      case 'end':
        return checklist

      default:
        if (mode === 'ncr') addNcr(checklist, row, index)
        else if (mode === 'work type') addWorkType(checklist, row, index)
        else if (mode === 'description') addDefectDetail(checklist, row, index)
        else mode = ''

        break
    }
  })

  return checklist
}

const addNcr = (checklist: CheckListDetail, row: string[], index: number) => {
  const name = getText(row, 1)
  if (name === '') return

  isDuplicate('DefectTypeName', name, checklist.DefectTypeList, index)
  checklist.DefectTypeList.push({
    DefectTypeID: 0,
    DefectTypeName: name,
    IsNCR: getText(row, 2) === 'yes',
  })
}

const addWorkType = (
  checklist: CheckListDetail,
  row: string[],
  index: number
) => {
  const name = getText(row, 1)
  if (name === '') return

  isDuplicate('WorkTypeName', name, checklist.WorkTypeList, index)
  checklist.WorkTypeList.push({
    WorkTypeID: 0,
    WorkTypeName: name,
    IndexID: getText(row, 2),
  })
}

const addDefectDetail = (
  checklist: CheckListDetail,
  row: string[],
  index: number
) => {
  const job = getText(row, 1)
  const jobScore = getInt(row, 2)
  const subJob = getText(row, 3)
  const detail = getText(row, 4)
  const major = getText(row, 5)
  const supplier = getText(row, 6)
  const score = getInt(row, 7)
  const ncrScore = getInt(row, 8)

  if (detail === '') return

  let jobItem: JobType = {
    JobTypeID: 0,
    JobTypeName: job,
    Score: jobScore,
    SubJobTypeList: [],
    WorkTypeList: [],
  }

  if (job !== '') {
    isDuplicate('JobTypeName', job, checklist.JobTypeList, index)
    jobItem.WorkTypeList = getWorkType(row, 9, checklist.WorkTypeList.length)
    checklist.JobTypeList.push(jobItem)
  }

  const jobIndex = checklist.JobTypeList.length - 1
  jobItem = checklist.JobTypeList[jobIndex]

  let subJobItem: SubJobType = {
    SubJobTypeID: 0,
    SubJobTypeName: subJob,
    DetailList: [],
  }

  if (subJob !== '') {
    isDuplicate('SubJobTypeName', subJob, jobItem.SubJobTypeList, index)
    jobItem.SubJobTypeList.push(subJobItem)
  }

  const subJobIndex = jobItem.SubJobTypeList.length - 1
  subJobItem = jobItem.SubJobTypeList[subJobIndex]

  const detailItem = {
    DetailID: 0,
    DetailName: detail,
    IsRequired: major === 'yes',
    IsSupplier: supplier === 'yes',
    Score: score,
    NCRScore: ncrScore,
  }
  // isDuplicate('DetailName', detail, subJobItem.DetailList, index)
  subJobItem.DetailList.push(detailItem)
}

const getWorkType = (row: string[], start: number, max: number) => {
  const work_list: any[] = []
  const len = row.length
  const lenMax = max + start
  for (let i = start; i < lenMax; i++) {
    const code = getText(row, i)
    if (code === '') return work_list

    work_list.push({
      WorkTypeID: 0,
      Index: code,
    })
  }

  return work_list
}
